/**
 * AuthCallback Component
 * Handles the session_id exchange after Google OAuth redirect
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import api from '../services/api';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          setError('Session ID manquant');
          setTimeout(() => navigate('/login'), 2000);
          return;
        }

        // Exchange session_id with backend
        const { data } = await api.post(
          '/auth/google/session',
          { session_id: sessionId },
          { withCredentials: true }
        );

        if (data.success) {
          // Check if profile needs completion (new Google user)
          if (data.needsProfileCompletion) {
            // Navigate to dashboard with flag to show role selection
            navigate('/', { 
              state: { 
                user: data.user,
                needsProfileCompletion: true,
                isNewUser: true
              },
              replace: true
            });
          } else {
            // Existing user or profile already completed
            await checkAuth();
            navigate('/', { replace: true });
          }
        } else {
          setError('Erreur d\'authentification');
          setTimeout(() => navigate('/login'), 2000);
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        setError(err.response?.data?.detail || 'Erreur d\'authentification');
        setTimeout(() => navigate('/login'), 2000);
      }
    };

    processAuth();
  }, [navigate, checkAuth]);

  if (error) {
    return (
      <div className="min-h-screen theme-bg flex items-center justify-center">
        <div className="text-center">
          <div className="text-red-500 text-xl mb-4">{error}</div>
          <div className="theme-text-secondary">Redirection vers la connexion...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen theme-bg flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#00d4ff] mx-auto mb-4"></div>
        <div className="theme-text text-xl">Authentification en cours...</div>
      </div>
    </div>
  );
};

export default AuthCallback;
